import React from 'react';
import DropdownButton from '../dropdowns/DropdownButton';

const FilterState = (props) => {
    const {toggleCongressDropdowns, congress, active, isMobile} = props;

    const propsValue = `state-${congress.filterDistrict.state}`;


    // need to check parent container state.
    // since we closing the state listing, we need to shorten the container panel height
    const districtFilterStatus = document.getElementsByClassName('congress-district-dropdowns open');
    if (districtFilterStatus.length === 1) {
      districtFilterStatus[0].classList.remove('longer');
    }

    return(
        <DropdownButton
          name={congress.selected.stateName}
          callFunction={toggleCongressDropdowns}
          chevron="down"
          callVal={propsValue}
          active={active}
          expanded="false"
          isMobile={isMobile}
          id="us-state-filter"
        />
    );
};

export default FilterState;
